import { createDateRangeFilterConfig } from '../factories/create-date-range-filter-config';
import { createSimpleFilterConfig } from '../factories/create-simple-filter-config';
import { buildDateRangeFacetKey } from '../helpers/build-date-range-facet-key';
import { FILTER_COLOR } from './filter-colors';

// The Automation list's static filters. The API takes `is_enabled`,
// `channel` and `target_scope` once; `toAutomationListParams` sends no param
// when both options are picked.

export const automationEnabledFilterConfig = createSimpleFilterConfig({
  facetName: 'is_enabled',
  friendlyField: 'Enabled',
  // On/off, from the row's switch: the Status chip says whether it's
  // answering now, which this filter can't (gap G13b).
  options: [
    { value: 'true', label: 'On' },
    { value: 'false', label: 'Off' },
  ],
});

export const automationChannelFilterConfig = createSimpleFilterConfig({
  facetName: 'channel',
  friendlyField: 'Channel',
  options: [
    { value: 'INSTAGRAM', label: 'Instagram' },
    { value: 'FACEBOOK', label: 'Facebook' },
  ],
});

export const automationPostFilterConfig = createSimpleFilterConfig({
  facetName: 'target_scope',
  friendlyField: 'On Post',
  options: [
    { value: 'ANY_POST', label: 'All Posts' },
    { value: 'SPECIFIC_POST', label: 'Specific Post' },
  ],
});

export const automationScheduleFilterConfig = createSimpleFilterConfig({
  facetName: 'schedule_status',
  friendlyField: 'Schedule',
  // "Running" is the API's ACTIVE schedule, so it isn't mistaken for the
  // Active status chip.
  options: [
    { value: 'SCHEDULED', label: 'Scheduled' },
    { value: 'ACTIVE', label: 'Running' },
    { value: 'ENDED', label: 'Ended' },
  ],
});

// The API's date filters are `created_after`/`created_before` and
// `updated_after`/`updated_before`, not the `*_at_*` names of other lists.
export const automationCreatedFilterConfig = createDateRangeFilterConfig({
  facetName: buildDateRangeFacetKey({
    before: 'created_before',
    after: 'created_after',
  }),
  color: FILTER_COLOR.yellow,
});

export const automationUpdatedFilterConfig = createDateRangeFilterConfig({
  facetName: buildDateRangeFacetKey({
    before: 'updated_before',
    after: 'updated_after',
  }),
  color: FILTER_COLOR.teal,
});
